import { Popup, type PopupProps } from '@progress/kendo-react-popup'
import React from 'react'
import { useClickAway, useToggle } from 'react-use'

import { Box } from '~/components/elements/Box'
import {
  IconButton,
  type IconButtonProps,
} from '~/components/elements/IconButton'

import styles from './DropDownIconButton.css'

const anchorAlign: PopupProps['anchorAlign'] = {
  horizontal: 'center',
  vertical: 'center',
}

const collision: PopupProps['collision'] = {
  horizontal: 'fit',
  vertical: 'fit',
}

const popupAlign: PopupProps['popupAlign'] = {
  horizontal: 'right',
  vertical: 'top',
}

export type DropDownIconButtonProps = Pick<IconButtonProps, 'icon'> & {
  children?: React.ReactNode
  'data-testid'?: string
}

export const DropDownIconButton = ({
  children,
  'data-testid': dataTestId = 'components-elements-drop-down-icon-button',
  icon,
}: DropDownIconButtonProps) => {
  const anchorRef = React.useRef<HTMLDivElement>(null)
  const popupContentRef = React.useRef<HTMLDivElement>(null)
  const [show, toggleShow] = useToggle(false)

  useClickAway(popupContentRef, toggleShow)

  return (
    <Box ref={anchorRef} className={styles.root} data-testid={dataTestId}>
      <IconButton fillMode="outline" icon={icon} onClick={toggleShow} />

      <Popup
        anchor={anchorRef.current}
        anchorAlign={anchorAlign}
        collision={collision}
        popupAlign={popupAlign}
        show={show}
      >
        <div ref={popupContentRef} onClick={toggleShow}>
          {children}
        </div>
      </Popup>
    </Box>
  )
}
